module.exports = __webpack_public_path__ + "static/img/qh1-5.3f3dfa1.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/qh1-5.png
// module id = 426
// module chunks = 0